import axios from 'axios';
import { Auth } from 'aws-amplify';
import { GET_ALL_DOCUMENTS } from '../../types';
import { ALL_DOCUMENTS } from '../../API';

export const getAllDocuments = () => async (dispatch) => {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.signInUserSession.idToken.jwtToken;
  const email = user.attributes.email;
  const userId = user?.username;

  try {
    const params = {
      email,
      userId,
    };

    const res = await axios.get(ALL_DOCUMENTS, {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer '.concat(token),
      },
      params,
    });
    // console.log('res.documents', res);

    if (res && res.data && res.data.success === true) {
      dispatch({
        type: GET_ALL_DOCUMENTS,
        payload: res.data.documents,
      });
    }
  } catch (err) {
    dispatch({
      type: GET_ALL_DOCUMENTS,
      payload: [],
    });
    if (err.response) {
      // The client was given an error response (5xx, 4xx)
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else if (err.request) {
      console.log(err.request);
      // The client never received a response, and the request was never left
    } else {
      console.log('Error', err.message);
    }
  }
};
